import React, {useCallback, useEffect, useState} from 'react';
import Icon from 'react-icons-kit';
import {ic_close} from 'react-icons-kit/md/ic_close';
import styled, { useTheme } from 'styled-components';
import {Circle} from 'better-react-spinkit';
import { LabelPosition } from '../../Const';

const Root = styled.div`
  display: flex;
  flex-direction: ${({labelPosition}) => {
    if (labelPosition === LabelPosition.LEFT) {
      return `row`;
    } else {
      return `column`;
    }
  }};
`;
const Label = styled.div`
   align-self: ${({labelPosition}) => {
    if (labelPosition === LabelPosition.LEFT) {
      return `center`;
    } else {
      return `left`;
    }
  }};
`;
const Input = styled.div`
  position: relative;
  flex-direction: row;
  display: flex;
  border: 1px solid #9e9e9e;
  border-radius: 3px;
  width: 100%;
  background: ${({disabled}) => disabled ? `#c6c6c6` : `#ffff`};
  & input {
    text-align: center;
    width: 100%;
    border: none;
    background: none;
    line-height: ${({size}) => {
  switch (size) {
    default:
    case 'M':
      return `32px`;
    case 'S':
      return `20px`;
    case 'XS':
      return `12px`;
  }
}};
    font-size: ${({size}) => {
  switch (size) {
    default:
    case 'M':
      return `1em`;
    case 'S':
      return `0.78em`;
    case 'XS':
      return `0.70em`;
  }
}};
  }
`
const ClearButton = styled.button`
  color: #616161;
  border: none;
  background: none;
  cursor: pointer;
  position: absolute;
  left: 0;
  align-self: center;
  margin: 2px;
`;
const SymbolicDate = styled.div`
  font-size: 0.65em;
  color: #ffffff;
  background: ${({theme}) => theme?.primaryColor};
  position: absolute;
  align-self: center;
  padding: 1px 2px;
  border-radius: 2px;
  margin: 2px;
  right: 0;
`;
const loadingStyle = {
  position: 'absolute',
  left: 0,
  top: 0,
  display: 'flex',
  width: '100%',
  alignItems: 'center',
  justifyContent: 'center',
  background: '#dededea6',
  height: '100%',
}

const CustomInput = (props) => {
  const {onChange, value, disabled, onClick, size, dpRef, clearable, clearSelectedDate, symbolicDate, loading, label, labelPosition, placeholder} = props;
  const [inputValue, setInputValue] = useState(value);

  useEffect(() => {
    setInputValue(value);
  }, [value]);

  const submitValue = useCallback(() => {
    onChange({target: {value: inputValue}});
    dpRef?.current?.setOpen(false);
  }, [dpRef, inputValue, onChange]);

  const onInputKeyDown = useCallback((event) => {
    if (event.key === 'Enter') {
      submitValue();
    }
  }, [submitValue]);

  const onInputChange = useCallback((event) => {
    setInputValue(event.target.value)
  }, []);

  const onInputBlur = useCallback(() => {
    if (value !== inputValue) {
      submitValue();
    }
  }, [inputValue, value, submitValue]);

  const closeIconSize = React.useMemo(() => {
    switch (size) {
      default:
      case 'M':
        return 18;
      case 'S':
        return 14;
      case 'XS':
        return 12;
    }
  }, [size]);

  const theme = useTheme();
  return (
    <Root labelPosition={labelPosition}>
      {label?.length > 0 && (
        <Label labelPosition={labelPosition}>{label}</Label>
      )}
      <Input disabled={disabled} size={size}>
        {loading && (<Circle color={theme.primaryColor} size={16} style={loadingStyle}/>)}
        {clearable && inputValue?.length > 0 && (
          <ClearButton onClick={clearSelectedDate}><Icon icon={ic_close} size={closeIconSize}/></ClearButton>)
        }
        {symbolicDate?.length > 0 && (
          <SymbolicDate>{symbolicDate}</SymbolicDate>
        )}
        <input
          value={inputValue}
          onChange={onInputChange}
          onKeyDown={onInputKeyDown}
          onBlur={onInputBlur}
          onClick={onClick}
          placeholder={placeholder}
        />
      </Input>
    </Root>
  );
};

class _DatePickerInput extends React.Component { //react-datepicker has a problem with using functional components with custom input
  render() {
    return <CustomInput {...this.props}/>
  }
}

export default _DatePickerInput;
